import { useState, useEffect, useCallback } from 'react';

/**
 * Listens for service worker update events dispatched by the registration module.
 * Returns state + a refresh handler that activates the new worker and reloads.
 */
export default function usePwaUpdate(): {
  updateAvailable: boolean;
  refresh: () => void;
} {
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);

  useEffect(() => {
    const handler = (e: Event): void => {
      setRegistration((e as CustomEvent).detail as ServiceWorkerRegistration);
    };
    window.addEventListener('trio-sw-update', handler);
    return () => window.removeEventListener('trio-sw-update', handler);
  }, []);

  const refresh = useCallback(() => {
    if (registration?.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    window.location.reload();
  }, [registration]);

  return {
    updateAvailable: !!registration,
    refresh,
  };
}
